import React, { FC, PropsWithChildren } from "react";

import "./FloorMapActionsGroup.scss";

export const FloorMapActionsGroup: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  return <div className="FloorMapActionsGroup">{children}</div>;
};
